import * as courseTemplateTypes from "Store/courseTemplates/constants";

const initialState: ICourseTemplatesReducer = {
  templates: [],
  orgTemplates: [],
  builtInTemplates: [],
  sessionSchedule: {},
  queryOptions: {},
  isLoading: false,
  selectedCourseTemplate: null
};

const handleActions = (state, action) => {
  switch (action.type) {
    case courseTemplateTypes.SET_COURSE_TEMPLATE:
      return {
        templates: action.payload
      };
    case courseTemplateTypes.SET_COURSE_TEMPLATES_BY_TYPE:
      return {
        [action.payload.templateType === "builtIn" ? "builtInTemplates" : "orgTemplates"]:
          action.payload.templates
      };
    case courseTemplateTypes.SET_COURSE_TEMPLATE_SESSIONS:
      return {
        sessionSchedule: action.payload
      };
    case courseTemplateTypes.SET_COURSE_TEMPLATE_QUERY:
      return {
        [action.queryType]: {
          ...state[action.queryType],
          [action.queryName]: action.query
        }
      };
    case courseTemplateTypes.SET_COURSE_TEMPLATES_FILTERS_CLEAR:
      return {
        queryOptions: action.payload
      };
    case courseTemplateTypes.SET_COURSE_TEMPLATE_LOADER:
      return {
        isLoading: action.payload
      };
    case courseTemplateTypes.SET_SELECTED_COURSE_TEMPLATE:
      return {
        selectedCourseTemplate: action.payload
      };

    default:
      return {};
  }
};

const courseTemplatesReducer = (state = initialState, action) => ({
  ...state,
  ...handleActions(state, action)
});

export default courseTemplatesReducer;
